import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import VueResource from "vue-resource";

import VueQRCodeComponent from "vue-qrcode-component";
import VueSVGIcon from "vue-svgicon";

import VueI18n from "vue-i18n";
import en from "./locale/en.js";
import es from "./locale/es.js";
import pt from "./locale/pt.js";

// import MockApi from "./services/mock-api-routes";

Vue.config.productionTip = false;

window.moment = require("moment");
window.tz = require("moment-timezone");

// Vue.use(Vuetify, {
//   theme: {
//     primary: "#37474F",
//     secondary: "#78909C",
//     error: "#D32F2F",
//     textOverPrimary: "#FFFFFF",
//     textOverSecondary: "#FFFFFF"
//   }
// });
const opts = {
  theme: {
    themes: {
      light: {
        primary: "#37474F",
        secondary: "#fff",
        error: "#D32F2F",
        textOverPrimary: "#FFFFFF",
        textOverSecondary: "#FFFFFF",
      },
    },
  },
};
Vue.use(Vuetify);

Vue.use(VueResource);

// Vue.http.interceptors.unshift((request, next) => {
//   let route = MockApi.routes.find(item => {
//     return request.method === item.method && request.url === item.url;
//   });
//   if (route) {
//     var response = route.response(request.body);
//     next(
//       request.respondWith(response, {
//         status: response !== false ? route.status : 403
//       })
//     );
//   } else {
//     next(request.respondWith({ status: 404 }));
//   }
// });

Vue.component("qr-code", VueQRCodeComponent);

Vue.use(VueI18n);

Vue.use(VueSVGIcon, {
  tagName: "icon",
});

const messages = {
  en: en,
  es: es,
  pt: pt,
};
const i18n = new VueI18n({
  locale:
    (navigator.language || navigator.userLanguage).split("-")[0] === "es"
      ? "es"
      : (navigator.language || navigator.userLanguage).split("-")[0] === "pt"
      ? "pt"
      : "en",
  messages,
});

new Vue({
  vuetify: new Vuetify(opts),
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
